var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-card',{staticStyle:{"height":"100%"},attrs:{"size":"small","bordered":false,"bodyStyle":{ height: '200px' }}},[_c('template',{slot:"title"},[_vm._v(_vm._s(_vm.$t("货品库存前十占比")))]),_c('div',{staticStyle:{"height":"100%"},attrs:{"id":"productStatsChart"}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }